import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export function GenerateMessage({ form, message, isSuccess }) {
	return (
		<>
			<div
				className={`modal-overlay toggleMessage-overlay ${form ? "open" : ""}`}
			>
				{form && (
					<div
						className="modal toggleMessage"
						style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
					>
						<div className="column">
							{isSuccess ? (
								<div
									className="request_title row"
									style={{
										fontWeight: "bold",
										color: "green",
										alignItems: "center",
									}}
								>
									<CheckCircleIcon />
									<span>{"SUCCESS MESSAGE"}</span>
								</div>
							) : (
								<div
									className="request_title row"
									style={{
										fontWeight: "bold",
										color: "#DD5746",
										alignItems: "center",
									}}
								>
									<ErrorIcon />
									<span>{"ERROR MESSAGE"}</span>
								</div>
							)}
							<span
								style={{
									textAlign: "center",
									padding: "10px 0",
									color: isSuccess ? "green" : "#DD5746",
								}}
							>
								{message}
							</span>
						</div>
					</div>
				)}
			</div>
		</>
	);
}